<template>
  <div :class="$style.container">
    <div :class="$style.wrapper">
      <img
        :class="$style.loaderPlaceholder"
        src="~public/img/jc-cloud-loader.gif"
      >
      <p :class="$style.text">
        We're getting you there with JumpCloud Go...
      </p>
      <p :class="$style.textRedirect">
        if you are not redirected in 5 seconds please click the link
        <a
          :class="$style.link"
          href="/login?autoGo=false"
        >here</a>
      </p>
      <LogoIcon :class="$style.logo" />
    </div>
  </div>
</template>

<script>
import LogoIcon from 'client/components/LogoIcon.vue';

export default {
  name: 'JumpcloudGoPageLoader',

  components: {
    LogoIcon,
  },
};
</script>

<style scoped module>
@value (jcPrimary) from 'css/brand-colors.css';

.container {
  background-color: #f0fcfd;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 999999;
}

.wrapper {
  align-items: center;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 6rem auto;
  max-width: 1000px;
  padding: 5rem 0 1rem 0;
}

.text {
  font-size: 1.5rem;
  margin-bottom: 0;
  margin-top: 3rem;
  text-align: center;
}

.textRedirect {
  margin: 1rem 0;
  text-align: center;
}

.loaderPlaceholder {
  height: 120px;
  object-fit: cover;
  width: 300px;
}

.link {
  color: jcPrimary;
  text-decoration: underline;
}

@media (max-width: 1058px) {
  .logo {
    margin: 3rem auto 2rem auto;
    position: static;
  }

  .container {
    background-color: #fff;
  }
}
</style>
